import PropTypes from 'prop-types';
import React from 'react';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Text} from '../../ui';
import Review from './Review';

const ReviewsListLayout = ({reviews}) => {
  const reviewsList = reviews.map((review) => (
    <Review
      key={review.id}
      rating={review.rating}
      user={review.user}
      comment={review.comment}
    />
  ));
  return (
    <div>
      {reviewsList.length ? (
        reviewsList
      ) : (
        <Text>
          <TextLocal id={'courseDetails.be-first-leave-review'} />
        </Text>
      )}
    </div>
  );
};

ReviewsListLayout.propTypes = {
  reviews: PropTypes.array,
};

export default ReviewsListLayout;
